import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.owner;

export const ownerSelectors = {
  totalItems: createSelector(selector, (owner) => owner.total_items),
  totalPages: createSelector(selector, (owner) => owner.total_pages),
  currentPage: createSelector(selector, (owner) => owner.current_page),
  pageSize: createSelector(selector, (owner) => owner.page_size),
  nextPage: createSelector(selector, (owner) => owner.next_page),
  previousPage: createSelector(selector, (owner) => owner.previous_page),
  owners: createSelector(selector, (owner) => owner.owners),
};
